module.exports = __webpack_public_path__ + "img/icon1.309bb552.png";